<script>
    import {Link} from 'svelte-routing';
    import { Splide, SplideSlide } from '@splidejs/svelte-splide';
    import '@splidejs/svelte-splide/css';
    import TopMenu from '../components/TopMenu.svelte';
    import Footer from '../components/Footer.svelte';
    import {store} from '../stores.js';
    import {list} from '../config.js';
    import {load_order, load_client} from '../events.js';

	const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);
    const amo = store('amo', '', false);
    const cart = store('cart-items', '', '[]');
    const cart_data = store('cart-data', '', '{"id": 0, "nomDoc": -1, "nomDocStr": "", "fio": "", "tel": "", "email": "", "address": "", "comment": "", "note": "", "markup_percent": 0, "discount_percent": 0, "tv": -1}');

    let wrapper;
    let playing = '';

    // очищаем корзину
    if ($amo) {
        cart.remove();
        cart_data.remove();
    }

    // заполняем данные по клиенту из заказа
    load_client(cart, cart_data, user);

    // загрузка заказа из ТМ
    load_order(cart, cart_data);

    const options = {
        perPage: 1,
        fixedWidth : '100%',
        pagination: false,
        lazyLoad: 'nearby',
        preloadPages: 0,
    };
</script>

 <TopMenu title="Выбор калькулятора" />

<div id="appCapsule" bind:this={wrapper}>
    <div class="section">
        <div class="row">
            {#each list as item (item.link)}
                {#if
                    (
                        $user && $user.calcs && $user.calcs.split(',').find((uc) => uc === item.calc)
                    ) && (
                        typeof item.hide === 'undefined' ||
                        item.hide === false
                    )
                }
                    <div class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-2 d-flex align-items-stretch">
                        <div class="card flex-fill">
                            {#if !$axis}
                                {#if item.img.length }
                                    {#if item.img.includes(',')}
                                        <Splide options={options}>
                                            {#each item.img.split(',') as img (img)}
                                                <SplideSlide>
                                                    <img data-splide-lazy="{ img }" class="card-img-top" alt="{ item.title }" style="height: 300px; width: auto; object-position: center center; object-fit: cover;" />
                                                </SplideSlide>
                                            {/each}
                                        </Splide>
                                    {:else}
                                        <Link to="/calc/{ item.link }">
                                            {#if item.img.includes('mp4') }
                                                {#if playing === item.link}
                                                    <video class="card-img-top" width="320" height="240" controls autoplay muted playsinline style="height: 300px; width: 100%; object-position: center center; object-fit: cover;" >
                                                        <source src="{ item.img }" type="video/mp4">
                                                        Ваш браузер не поддерживает тег video.
                                                    </video>
                                                {:else}
                                                    <span class="card-img-top d-flex align-items-center justify-content-center" style="height: 300px; background: #1c1c1e;">
                                                        <button type="button" class="btn btn-light" on:click|preventDefault|stopPropagation={() => playing = item.link}>Смотреть видео</button>
                                                    </span>
                                                {/if}
                                            {:else}
                                                <img src="{ item.img }" loading="lazy" class="card-img-top" alt="{ item.title }" style="height: 300px; width: 100%; object-position: center center; object-fit: cover;" />
                                            {/if}
                                        </Link>
                                    {/if}
                                {/if}
                            {/if}
                            <div class="card-body pt-2">
                                <h4 class="mb-0">{ item?.alt?.[$user.idSklad] ?? item.title }</h4>
                                <p class="mb-0">{ item.description }</p>
                            </div>
                            <div class="card-footer border-0 p-0">
                                <Link to="/calc/{ item.link }" class="btn btn-primary btn-block">Открыть</Link>
                            </div>
                        </div>
                    </div>
                {/if}
            {/each}
        </div>
    </div>
</div>

<Footer />
